"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.Grid = void 0;
var react_1 = __importDefault(require("react"));
var css_1 = require("@emotion/css");
var Box_1 = require("../Box");
var Grid = function (_a) {
    var areas = _a.areas, className = _a.className, columns = _a.columns, rows = _a.rows, restProps = __rest(_a, ["areas", "className", "columns", "rows"]);
    return (react_1["default"].createElement(Box_1.Box, __assign({}, restProps, { className: (0, css_1.cx)((0, css_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        display: grid;\n        ", "\n        ", "\n        ", "\n      "], ["\n        display: grid;\n        ", "\n        ", "\n        ", "\n      "])), columns && "grid-template-columns: ".concat(columns, ";"), rows && "grid-template-rows: ".concat(rows, ";"), areas && "grid-template-areas: ".concat(areas, ";")), className) })));
};
exports.Grid = Grid;
var templateObject_1;
